/**
 * Fuel filter grouping, mirrored by the SQL function public.fuel_filter_codes.
 * Input: URL/filter values (comma separated, any language/diacritics).
 * Output: listings_v2.fuel_type codes that match, or null when no filter.
 * "hybrid"/"hibrid" covers hybrid + plug-in hybrid.
 */
const GROUPS: Record<string, string[]> = {
  diesel: ["diesel"], motorina: ["diesel"],
  benzina: ["benzina"], benzin: ["benzina"], petrol: ["benzina"], gasoline: ["benzina"],
  hybrid: ["hybrid", "hybrid_plugin"], hibrid: ["hybrid", "hybrid_plugin"],
  hybridplugin: ["hybrid_plugin"], hibridplugin: ["hybrid_plugin"], pluginhybrid: ["hybrid_plugin"],
  pluginhibrid: ["hybrid_plugin"], phev: ["hybrid_plugin"],
  electric: ["electric"], electrica: ["electric"], ev: ["electric"],
  lpg: ["lpg"], gpl: ["lpg"],
};

const normToken = (s: string) =>
  s.trim().toLowerCase().normalize("NFKD").replace(/[\u0300-\u036f]/g, "").replace(/[^a-z0-9]/g, "");

export function fuelFilterCodes(value: string | null | undefined): string[] | null {
  if (!value || !value.trim()) return null;
  const out = new Set<string>();
  for (const tok of value.split(",")) {
    const k = normToken(tok);
    if (!k) continue;
    for (const c of GROUPS[k] ?? [k]) out.add(c);
  }
  return out.size ? [...out] : null;
}

/** True when a listing's main fuel_type matches the filter value. */
export function matchesFuel(fuelType: string | null | undefined, value: string | null | undefined): boolean {
  const codes = fuelFilterCodes(value);
  if (!codes) return true;
  return !!fuelType && codes.includes(fuelType);
}

/** Whether a URL segment is a known fuel word (used when /cars/{make}/{fuel}). */
export const isKnownFuelSlug = (value: string | null | undefined) => !!value && normToken(value) in GROUPS;
